module.exports = __webpack_public_path__ + "assets/151856d035baf9a82826eef85636a56b.png";